import type { PropsWithChildren, ReactNode } from 'react'

import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { LinkedInNotLogged } from 'components/molecules/linkedInNotLogged/LinkedInNotLogged.tsx'
import ModalPersonas from 'components/molecules/ModalPersonas'
import ModalWindow from 'components/molecules/ModalWindow'
import { HomeTemplate } from 'components/templates/homeTemplate'

import { api } from '../../api'
import { useIsEnable, useSidebar } from '../../hooks'
import { Fallbacks } from '../Fallbacks/Fallbacks'
import { closeInvite, openInvite, useInviteModal } from './useInviteModal'

Wrapper.openInvite = openInvite

export function Wrapper({
	children,
	header
}: PropsWithChildren & {
	header: ReactNode
}) {
	const showMembers = useIsEnable()

	const query = api.usePersonasQuery(undefined, {
		skip: !showMembers
	})

	useSidebar()

	const isOpen = useInviteModal()

	return (
		<HomeTemplate id='teams'>
			<LinkedInNotLogged />

			<ModalWindow
				classes='invite-modal'
				closeHandler={closeInvite}
				open={isOpen}
			>
				<ModalPersonas
					getPersonas={query.refetch}
					setIsModalInvitedOpen={closeInvite}
				/>
			</ModalWindow>
			{header}

			{query.isLoading && <FullLoader size={60} />}

			<Fallbacks />

			{query.isSuccess && children}
		</HomeTemplate>
	)
}
